const $filters_cols = $(".filters_cols");

$(".filter-link").on("click", function(e) {
  e.preventDefault();
  const $this = $(this);
  $this.closest(".sort-filter__col").toggleClass("active").siblings().removeClass("active");
});

$filters_cols.find(".filter-check input").on("change", function() {
  var $this = $(this);
  $this.closest("li").siblings().find("input").prop("checked", false);
});

$filters_cols
  .on("submit", function(e) {
    e.preventDefault();
    let collectionUrl = $filters_cols.data("collection-url");
    const collectionSort = $filters_cols.data("sort");
    let filterTags = "/";
    $filters_cols.find(".filter-check input:checked").each(function() {
      filterTags = filterTags + $(this).val() + "+";
    });
    filterTags = filterTags.replace(/\+$/, "");
    collectionUrl += filterTags;
    if (collectionSort.length > 1) {
      collectionUrl += "?sort_by=" + collectionSort;
    }
    window.location.href = decodeURIComponent(collectionUrl);
  })
  .on("click", '[type="reset"]', function() {
    let collectionUrl = $filters_cols.data("collection-url");
    window.location.pathname = collectionUrl;
  });

$(".collection__utility .custom-select .current").on("click", function() {
  $(this).closest(".sort-filter__col").toggleClass("active").siblings().removeClass("active");
});



// WEBPACK FOOTER //
// ../assets/js/filters.js